import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import {
  Button,
  ListGroup,
  ListGroupItem,
  // NavbarToggler,
  Nav, Navbar, NavItem, NavLink,
  Popover, PopoverBody,
  Card, CardTitle, CardSubtitle, CardBody
} from 'reactstrap';
import {
  MdClearAll,
  MdExitToApp,
  MdNotificationsNone,
  MdNotificationsActive,
  MdSettingsApplications,
  MdAttachMoney,
  MdTransform,
  MdHelp,
  MdLock
} from 'react-icons/md';
import { Link } from 'react-router-dom';
import HeaderNotificationComponent from '../../Customer/notifications/HeaderNotificationComponent';
import withBadge from '../../../hocs/withBadge';
import LoginAsAdmin from "./LoginAsAdmin";

const MdNotificationsActiveWithBadge = withBadge(
  {
    size: 'md',
    color: 'primary',
    style: {
      top: -10,
      right: -10,
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    // children: <small>5</small>,
  }
)(MdNotificationsActive);

class HeaderCustomer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isOpenNotificationPopover: false,
      isNotificationConfirmed: false,
      isOpenUserCardPopover: false,
    };
    this.wrapperRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    this.getUnReadNotifications();
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (e) => {
    if (this.wrapperRef.current && !this.wrapperRef.current.contains(e.target))               {
      this.setState({ 
        isOpenUserCardPopover: false,
        isOpenNotificationPopover: false,
      });
    }
  }

  handleSidebarControlButton = event => {
    event.preventDefault();
    event.stopPropagation();
  
    document.querySelector('.cr-sidebar').classList.toggle('cr-sidebar--open');
  };
  
  toggleNotificationPopover = () => {
    this.setState({
      isOpenNotificationPopover: !this.state.isOpenNotificationPopover,
    });
  
    if (!this.state.isNotificationConfirmed) {
      this.setState({ isNotificationConfirmed: true });
    }
  };

  toggleUserCardPopover = () => {
    this.setState({
      isOpenUserCardPopover: !this.state.isOpenUserCardPopover,
    });
  };

  getUnReadNotifications = () => {
    let dataAuth = {
        username: process.env.REACT_APP_CLIENT_ID,
        password: process.env.REACT_APP_CLIENT_PASSWD,
        token: process.env.REACT_APP_KEY,
    };

    let config = {
          headers: {
            'Content-Type': 'application/json',
            'Authorization' : this.props.token,
            'dataAgency' : JSON.stringify(dataAuth)
        } 
    }

    axios.get(process.env.REACT_APP_API_URL + '/api/notification/get-unread-notifications', config )
    .then((ref) => {
        // console.log(ref.data);
        if (ref.data.error === 0) {
            this.updateNotification(ref.data)
        } else {
            if (ref.data.error > 9000) {
                this.props.logOut();
            } else {
                this.setState({
                    error: true,
                    messageError: ref.data.message
                })
            }
        }
    })
    .catch((error) => {
        console.log(error);
        this.setState({
            error: true,
            messageError: 'Lấy dữ liệu thông báo thất bại',
        })
    })
  }

  updateNotification = (data) => {
      let itemNotification = {
          notifications: data.notifications,
          unread_notification: data.unread_notification
      }
      this.props.updateNotification(itemNotification);
  }

  addCommas = (nStr) => {
    nStr += '';
    let x = nStr.split('.');
    let x1 = x[0];
    let x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        // eslint-disable-next-line no-useless-concat
        x1 = x1.replace(rgx, '$1' + '.' + '$2');
    }
    return x1 + x2;
  }

  logOut = async () => {
      let dataAuth = {
          username: process.env.REACT_APP_CLIENT_ID,
          password: process.env.REACT_APP_CLIENT_PASSWD,
          token: process.env.REACT_APP_KEY,
      };

      let config = {
          headers: {
              'Content-Type': 'application/json',
              'Authorization' : this.props.token,
              'dataAgency' : JSON.stringify(dataAuth)
          }
      }
      await axios.get(process.env.REACT_APP_API_URL + '/api/logOut', config );
      await this.props.logOut();
  }

  render() {
    return (
      <Navbar light expand className="cr-header bg-white navbar navbar-expand navbar-light">
        <Nav navbar className="mr-2">
          <Button outline onClick={this.handleSidebarControlButton}>
            <MdClearAll size={25} />
          </Button>
        </Nav>
        <Nav navbar>
        </Nav>

        <Nav navbar className="cr-header__nav-right navbar-nav">
          {
              this.props.sessionAdmin || this.props.isMenuAdmin ? (
                  <LoginAsAdmin />
              ) : (
                  <></>
              )
          }
          <NavItem className="d-inline-flex align-items-center">
            <div className="info-balance">
              <div className="text-center">
                Số dư
              </div>
              <div className="text-center text-danger">
                { this.addCommas( this.props.credit ) } ₫
              </div>
            </div>
          </NavItem>

          <NavItem className="d-inline-flex">
            <NavLink id="Popover1" className="position-relative">
              {this.props.unread_notification === 0 ? (
                <MdNotificationsNone
                  size={25}
                  className="text-secondary can-click"
                  onClick={this.toggleNotificationPopover}
                />
              ) : (
                <MdNotificationsActiveWithBadge
                  size={25}
                  className="text-secondary can-click animated swing infinite"
                  onClick={this.toggleNotificationPopover}
                  unread_notification = {this.props.unread_notification}
                />
              )}
            </NavLink>
            <Popover
              placement="bottom"
              isOpen={this.state.isOpenNotificationPopover}
              toggle={this.toggleNotificationPopover}
              target="Popover1"
              innerRef={this.wrapperRef}
            >
              <PopoverBody>
                <HeaderNotificationComponent />
              </PopoverBody>
            </Popover>
          </NavItem>

          <NavItem>
            <NavLink id="Popover2">
              <img src={ this.props.user.avatar } alt='avatar' onClick={this.toggleUserCardPopover} className="rounded-circle can-click nav-avatar" />
            </NavLink>
            <Popover
              placement="bottom-end"
              isOpen={this.state.isOpenUserCardPopover}
              toggle={this.toggleUserCardPopover}
              target="Popover2"
              className="p-0 border-0"
              style={{ minWidth: 250 }}
              innerRef={this.wrapperRef}
            >
              <PopoverBody className="p-0 border-light">
                <Card inverse className="bg-gradient-theme border-light">
                    <CardBody className="d-flex justify-content-center align-items-center flex-column">
                        <img src={ this.props.user.avatar } alt='avatar' onClick={this.toggleUserCardPopover} className="rounded-circle can-click mb-2 nav-avatar-detail" />
                        <CardTitle>{ this.props.user.name }</CardTitle>
                        <CardSubtitle>{ this.props.user.email }</CardSubtitle>
                    </CardBody>
                    <ListGroup flush>
                        <Link className='border-light list-group-item-action list-group-item' to={"/thong-tin-ca-nhan.html"}>
                            <MdSettingsApplications /> Thông tin cá nhân
                        </Link>
                        <Link className='border-light list-group-item-action list-group-item' to={"/doi-mat-khau.html"}>
                            <MdLock /> Đổi mật khẩu
                        </Link>
                        <Link className='border-light list-group-item-action list-group-item' to={"/quan-ly-giao-dich/nap-tien-tai-khoan.html"}>
                            <MdAttachMoney /> Nạp tiền tài khoản
                        </Link>
                        <Link className='border-light list-group-item-action list-group-item' to={"/quan-ly-giao-dich/lich-su-giao-dich.html"}>
                            <MdTransform /> Giao dịch
                        </Link>
                        <Link className='border-light list-group-item-action list-group-item' to={"/ho-tro/danh-sach-ho-tro.html"}>
                            <MdHelp /> Hỗ trợ
                        </Link>
                        <ListGroupItem tag="button" action className="border-light" onClick={ () => this.logOut() }>
                            <MdExitToApp /> Signout
                        </ListGroupItem>
                    </ListGroup>
                </Card>
              </PopoverBody>
            </Popover>
          </NavItem>
        </Nav>
      </Navbar>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.login.token,
    user: state.user.user,
    sessionRole: state.user.sessionRole,
    credit: state.user.credit,
    notifications: state.user.notifications,
    unread_notification: state.user.unread_notification,
    sessionAdmin: state.infoAdmin.isAdmin,
    isMenuAdmin: state.infoAdmin.isMenuAdmin,
  }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'CustomerHeader' }))
        },
        updateNotification: (item) => {
            dispatch(({type: 'updateNotification', item}))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(HeaderCustomer);